import { render, staticRenderFns } from "./AddDataRecord.vue?vue&type=template&id=406a1973&scoped=true"
import script from "./AddDataRecord.vue?vue&type=script&lang=js"
export * from "./AddDataRecord.vue?vue&type=script&lang=js"
import style0 from "./AddDataRecord.vue?vue&type=style&index=0&id=406a1973&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "406a1973",
  null
  
)

export default component.exports